import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label }) => (
  <div className="flex items-center gap-4 mb-6">
    <span className="eyebrow">{String(index).padStart(2, "0")}</span>
    <span className="h-px w-10 bg-gradient-to-r from-[#FFD700] to-transparent" />
    <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#999999]">
      {label}
    </span>
  </div>
);
